import styled, { css } from 'styled-components'

import { AVATAR_SIZES, type AvatarSize } from '../constants/avatarSizes'
import { boxShadow } from '@ui/utils/boxShadow'

export type AvatarViewingContext = 'self' | 'others'

export interface IAvatarStyledProps {
  $size: AvatarSize
  $shadow?: boolean
  $viewingContext: AvatarViewingContext
}

export const AvatarStyled = styled.div<IAvatarStyledProps>`
  ${(props) => {
    const { theme, $viewingContext, $size } = props
    const { background, text } = theme.colors.avatar[$viewingContext]
    const size = theme.typography.pxToRem(AVATAR_SIZES[$size].diameterPx)

    return css`
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      width: ${size};
      min-width: ${size};
      aspect-ratio: 1 / 1;

      background: ${background};
      color: ${text};

      border-radius: 50%;
      overflow: hidden;

      ${props.$shadow ? boxShadow() : null};
    `
  }}
`

AvatarStyled.displayName = 'AvatarStyled'
